var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c("div", { staticClass: "page-options" }, [
        _c(
          "a",
          {
            staticClass: "page-option-menu-btn",
            attrs: { title: _vm.itemidDisplay, href: "javascript:" },
            on: {
              click: function ($event) {
                return _vm.toggleMenu()
              },
            },
          },
          [
            _c("font-awesome-icon", {
              staticClass: "icon icon-gear",
              attrs: { icon: _vm.iconGear, title: "Page Options" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.showMenu
          ? _c(
              "ul",
              { staticClass: "node-options" },
              [
                _vm._l(_vm.localTasks, function (link) {
                  return _c(
                    "li",
                    { key: link.title, staticClass: "node-option" },
                    [
                      _c(
                        "a",
                        {
                          class: link.class,
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.execLocalTask(link)
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "icon-container" },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "icon",
                                attrs: { icon: link.icon, "fixed-width": "" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "text" }, [
                            _vm._v(
                              "\n          " + _vm._s(link.title) + "\n        "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "node-option node-id" },
                  [
                    _c(
                      "b-input-group",
                      [
                        _c("b-form-input", {
                          attrs: { value: _vm.itemidDisplay, disabled: "" },
                        }),
                        _vm._v(" "),
                        _c(
                          "b-input-group-append",
                          [
                            _c(
                              "b-btn",
                              {
                                attrs: { variant: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copyStringToClipboard(
                                      _vm.itemidDisplay
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n            Copy\n          ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.copied
                      ? _c("small", { staticClass: "success" }, [
                          _vm._v("\n        Copied"),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              2
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }